import isPlainObject from "lodash/isPlainObject";

/**
 * JSON Merge Patch (RFC 7396). Arrays replace wholesale per the standard;
 * objects merge recursively; `null` deletes a key.
 */
export const defaultMergePatch = (state: unknown, diff: unknown): unknown => {
  if (diff === null) return null;

  if (Array.isArray(diff)) return diff;

  if (isPlainObject(diff)) {
    return mergeObjects(state, diff as Record<string, unknown>);
  }

  return diff;
};

const mergeObjects = (
  state: unknown,
  diff: Record<string, unknown>,
): Record<string, unknown> => {
  const stateObj: Record<string, unknown> = isPlainObject(state)
    ? (state as Record<string, unknown>)
    : {};
  const result: Record<string, unknown> = { ...stateObj };
  for (const [key, value] of Object.entries(diff)) {
    if (value === null) {
      delete result[key];
    } else {
      result[key] = defaultMergePatch(stateObj[key], value);
    }
  }
  return result;
};
